
const GetPowerSteeringKpiReducer = (state = { type: 'LOADING_POWERSTEERING_DETAIL_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_POWERSTEERING_DETAIL_VIEW_ACTION':
            return action
        default:
            return state
    }
}

const GetPowerSteeringMainReducer = (state = { type: 'LOADING_POWERSTEERING_CARD_ACTION', data: {} }, action) => {
    
    switch (action.type) {
        case 'SUCCESS_POWERSTEERING_CARD_ACTION':
            return action
        default:
            return state
    }
}

export {
    GetPowerSteeringKpiReducer,
    GetPowerSteeringMainReducer
}